import { createContext } from "react";


const UserContext=createContext({
    loggedInUser: "Salian",
});

export default UserContext;